/* eslint-disable no-param-reassign */
import { GstplnAppCategory } from '@/components/apps/app';
import Vue from 'vue';

import CampaignFilterApp from '@/components/apps/campaign-filter/campaign-filter';
import ExportApp from '@/components/apps/export/export';
import StripeApp from '@/components/apps/stripe/stripe';
import StripeConnectApp from '@/components/apps/stripe-connect/stripe-connect';
import MollieConnectApp from '@/components/apps/mollie-connect/mollie-connect';
import DyflexisApp from '@/components/apps/dyflexis/dyflexis';
import BooqPlannerApp from '@/components/apps/booq-planner/booq-planner';
import SimpleCampaignApp from '@/components/apps/simpleCampaignApp/simpleCampaignApp';
import GiftcardsApp from '@/components/apps/giftcards/giftcards';
import AnnoncerApp from '@/components/apps/annoncer/annoncer';
import UntillApp from '@/components/apps/untill/untill';
import LightspeedApp from '@/components/apps/lightspeed-lseries/lightspeed-lseries';
import DishPosApp from '@/components/apps/dish-pos/dish-pos';
import MewsApp from '@/components/apps/mews/mews';
import YeatApp from '@/components/apps/yeat/yeat';
import { initializeApps } from './apps';

export default function createApps(vue: Vue) {
  const apps = [
    new CampaignFilterApp(vue),
    new ExportApp(vue),

    new SimpleCampaignApp(vue, 'app.actievandedag', {
      categories: [GstplnAppCategory.BookingPartners],
      allowedCountries: ['NL'],
      hasDarkIcon: true,
    }),
    new SimpleCampaignApp(vue, 'app.tripper', {
      categories: [GstplnAppCategory.BookingPartners],
      allowedCountries: ['NL'],
      hasDarkIcon: true,
    }),
    new SimpleCampaignApp(vue, 'app.diningcity', {
      categories: [GstplnAppCategory.BookingPartners],
      allowedCountries: ['NL', 'BE'],
    }),

    new SimpleCampaignApp(vue, 'app.heerlijk', {
      categories: [GstplnAppCategory.BookingPartners],
      allowedCountries: ['NL'],
    }),

    new SimpleCampaignApp(vue, 'app.socialdeal', {
      categories: [GstplnAppCategory.BookingPartners],
      allowedCountries: ['NL', 'BE'],
    }),

    new SimpleCampaignApp(vue, 'app.hightea', {
      categories: [GstplnAppCategory.BookingPartners],
      allowedCountries: ['NL'],
    }),
    new SimpleCampaignApp(vue, 'app.gault-millau', {
      categories: [GstplnAppCategory.BookingPartners],
      hasDarkIcon: true,
    }),
    new SimpleCampaignApp(vue, 'app.unbookables', {
      categories: [GstplnAppCategory.BookingPartners],
      allowedCountries: ['NL'],
    }),
    new SimpleCampaignApp(vue, 'app.debuik', {
      categories: [GstplnAppCategory.BookingPartners],
      allowedCountries: ['NL'],
    }),
    new SimpleCampaignApp(vue, 'app.dinee', {
      categories: [GstplnAppCategory.BookingPartners],
    }),
    new SimpleCampaignApp(vue, 'app.runnrai', { categories: [GstplnAppCategory.Integrations], underPaywall: true }),
    new AnnoncerApp(vue),
    new SimpleCampaignApp(vue, 'app.bookdinners', { categories: [GstplnAppCategory.BookingPartners] }),
    new SimpleCampaignApp(vue, 'app.breeze-social', { categories: [GstplnAppCategory.BookingPartners] }),
    new SimpleCampaignApp(vue, 'app.nappkin', { categories: [GstplnAppCategory.BookingPartners] }),
    new SimpleCampaignApp(vue, 'app.my-lucky-table', { categories: [GstplnAppCategory.BookingPartners] }),
    new SimpleCampaignApp(vue, 'app.bonnie', { categories: [GstplnAppCategory.Integrations], underPaywall: true }),

    new SimpleCampaignApp(vue, 'app.shiftbase', { categories: [GstplnAppCategory.Integrations], underPaywall: true }),
    new SimpleCampaignApp(vue, 'app.workfeed', {
      categories: [GstplnAppCategory.Integrations],
      underPaywall: true,
      hasDarkIcon: true,
    }),
    new SimpleCampaignApp(vue, 'app.mice', { categories: [GstplnAppCategory.Integrations], underPaywall: true }),
    new SimpleCampaignApp(vue, 'app.sem', { categories: [GstplnAppCategory.Integrations], underPaywall: true }),
    new SimpleCampaignApp(vue, 'app.afterhours', { categories: [GstplnAppCategory.BookingPartners] }),
    new SimpleCampaignApp(vue, 'app.carello', { categories: [GstplnAppCategory.BookingPartners] }),

    new StripeApp(vue),
    new StripeConnectApp(vue),
    new MollieConnectApp(vue),
    new DyflexisApp(vue),
    new BooqPlannerApp(vue),
    new GiftcardsApp(vue),
    new UntillApp(vue),
    new LightspeedApp(vue),
    new DishPosApp(vue),
    new MewsApp(vue),
    new YeatApp(vue),
  ];

  initializeApps(apps);
}
